<script>
    import { onMount } from "svelte";
    import { jsPDF } from "jspdf";
    import {
        super2,
        nozzle_qty_1,
        nozzle_diam_1,
        nozzle_qty_2,
        nozzle_diam_2,
        nozzle_qty_3,
        nozzle_diam_3,
        flow_rate,
        mud_weight,
        bit_size,
        bitSizeDisplayUnit,
        nozzleSizeDisplayUnit,
        tfaDisplayUnit,
        tfaSigFigs,
        flowRateDisplayUnit,
        mudWtDisplayUnit,
        pressureDropDisplayUnit,
        jetVelocityDisplayUnit,
        jetImpactForceDisplayUnit,
        hhpDisplayUnit,
        hsiDisplayUnit,
        tfa_1,
        tfa_2,
        tfa_3,
        tfa_total,
        jet_velocity,
        jet_impact_force,
        pressure_drop_at_bit,
        hhp,
        hsi,
    } from "../../public/stores";
    $: tfaDisplayPrint = "(" + $tfaDisplayUnit + super2 + ")";
    $: flowRateDisplayPrint = "(" + $flowRateDisplayUnit + ")";
    $: mudWtDisplayPrint = "(" + $mudWtDisplayUnit + ")";

    // PDF Printing
    const filename = "Ulterra QuickCalc.pdf";
    function createPDF() {
        const logo_height = 15;
        const vert_increment = 7;
        let pdf_height = 86;
        if ($nozzle_qty_2 > 0) {
            pdf_height += vert_increment;
        }
        if ($nozzle_qty_3 > 0) {
            pdf_height += vert_increment;
        }
        let pdf = new jsPDF("l", "mm", [100, pdf_height]); // width, height
        pdf.setDrawColor(0, 146, 159);
        pdf.text(60, logo_height * 0.66, "Bit Hydraulics");
        pdf.line(0, logo_height, 100, logo_height);
        let vert_position = logo_height + 5;
        pdf.text(
            1,
            vert_position,
            `Bit Size: ${$bit_size} ${$bitSizeDisplayUnit}`
        );
        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Nozzles 1: ${$nozzle_qty_1} x ${$nozzle_diam_1}${$nozzleSizeDisplayUnit} = ${$tfa_1.toFixed(
                $tfaSigFigs
            )}${tfaDisplayPrint}`
        );
        if ($nozzle_qty_2 > 0) {
            vert_position += vert_increment;
            pdf.text(
                1,
                vert_position,
                `Nozzles 2: ${$nozzle_qty_2} x ${$nozzle_diam_2}${$nozzleSizeDisplayUnit} = ${$tfa_2.toFixed(
                    $tfaSigFigs
                )}${tfaDisplayPrint}`
            );
        }
        if ($nozzle_qty_3 > 0) {
            vert_position += vert_increment;
            pdf.text(
                1,
                vert_position,
                `Nozzles 3: ${$nozzle_qty_3} x ${$nozzle_diam_3}${$nozzleSizeDisplayUnit} = ${$tfa_3.toFixed(
                    $tfaSigFigs
                )}${tfaDisplayPrint}`
            );
        }
        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Total TFA: ${$tfa_total.toFixed($tfaSigFigs)} ${tfaDisplayPrint}`
        );
        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Flow Rate: ${$flow_rate} ${flowRateDisplayPrint}`
        );
        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Mud Wt: ${$mud_weight} ${mudWtDisplayPrint}`
        );

        pdf.line(0, vert_position + 2, 100, vert_position + 2);

        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Jet Velocity: ${$jet_velocity.toFixed(
                1
            )} ${$jetVelocityDisplayUnit}`
        );
        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Jet Impact: ${$jet_impact_force.toFixed(
                1
            )} ${$jetImpactForceDisplayUnit}`
        );
        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Bit Pressure Drop: ${$pressure_drop_at_bit.toFixed(
                1
            )} ${$pressureDropDisplayUnit}`
        );
        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Hydraulic Power: ${$hhp.toFixed(1)} ${$hhpDisplayUnit}`
        );
        vert_position += vert_increment;
        pdf.text(
            1,
            vert_position,
            `Hydraulic Power/Area: ${$hsi.toFixed(3)} ${$hsiDisplayUnit}`
        );

        let image = new Image();
        let img_height = 0;
        let img_width = 0;
        image.src = "/Ulterra Horizontal Dark Gray.png";
        image.onload = function () {
            img_height = image.naturalHeight;
            img_width = image.naturalWidth;
            let img_ratio = img_width / img_height;
            let print_height = logo_height;
            let print_width = print_height * img_ratio;
            pdf.addImage(image, "PNG", 0, 0, print_width, print_height); //base64 image, format, x-coordinate, y-coordinate, width, height
            pdf.save(filename);
        };
    }
    onMount(() => {
        const share_button = document.getElementById("share-results-button");
        share_button.addEventListener("click", createPDF);
    });
</script>

<style>
    #share-results-button:hover {
        cursor: pointer;
        background-color: #047a85;
    }
</style>

<main>
    <div id="share-results-button" style="display: flex; align-items: center;">
        <div>Share Results PDF</div>
        <svg
            style="margin-left: 5px;"
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-share-2"><circle cx="18" cy="5" r="3" />
            <circle cx="6" cy="12" r="3" />
            <circle cx="18" cy="19" r="3" />
            <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
            <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" /></svg>
    </div>
</main>
